import Immutable from 'immutable';

import {
  CLEAR_LEGAL_MANIFEST_TICKET,
  CLEAR_LEGAL_MANIFEST_TICKETS,
  FLAG_GETTING_LEGAL_MANIFEST_TICKETS,
  GET_LEGAL_MANIFEST_TICKET,
  FLAG_LEGAL_MANIFEST_TICKET_ACTIVITY,
  GET_LEGAL_MANIFEST_TICKETS,
} from '../../../actions/types/legal'


const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.List(),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_LEGAL_MANIFEST_TICKETS:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_LEGAL_MANIFEST_TICKETS:
      return state.setIn(['all', 'content'], Immutable.List(action.payload));
    case CLEAR_LEGAL_MANIFEST_TICKETS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_LEGAL_MANIFEST_TICKET_ACTIVITY:
      if (action.payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(action.payload),
        );
      }
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_LEGAL_MANIFEST_TICKET:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case CLEAR_LEGAL_MANIFEST_TICKET:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
